import { Document, pdf } from "@react-pdf/renderer";
import toast from "react-hot-toast";
import PdfComponent from "src/views/manage-booking-orders/PdfComponent";

export const generatePDF = async (data, filteredData) => {
  console.log("Processs started");
  const MyDocument = () => (
    <Document>
      <PdfComponent data={data} filteredData={filteredData} />
    </Document>
  );
  console.log("document created");

  console.log("generating pdf");
  const pdfBlob = await pdf(<MyDocument />).toBlob();
  console.log("pdfBlob created");
  const pdfUrl = URL.createObjectURL(pdfBlob);

  const link = document.createElement("a");
  link.href = pdfUrl;
  link.download = "booking-order.pdf";
  link.click();
  console.log("pdf downloaded");
};
